import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sun, Moon, ArrowRight } from "lucide-react";

export function ThemeToggle() {
  const { theme, toggleTheme } = useAuth();
  const [showHint, setShowHint] = useState(() => !localStorage.getItem("ht_theme_hint_dismissed"));

  const handleClick = () => {
    if (showHint) {
      setShowHint(false);
      localStorage.setItem("ht_theme_hint_dismissed", "1");
    }
    toggleTheme();
  };

  return (
    <div className="flex items-center gap-2">
      {showHint && theme === "light" && (
        <div className="hidden sm:flex items-center gap-1.5 ht-fade-up" data-testid="dark-mode-hint">
          <span className="text-sm font-medium">Try out dark mode</span>
          <ArrowRight strokeWidth={1.5} className="w-4 h-4 animate-pulse" />
        </div>
      )}
      <Button variant="ghost" size="icon" onClick={handleClick} className="rounded-sm" data-testid="theme-toggle">
        {theme === "dark" ? <Sun strokeWidth={1.5} className="w-5 h-5" /> : <Moon strokeWidth={1.5} className="w-5 h-5" />}
      </Button>
    </div>
  );
}
